/* eslint-disable react/sort-comp */
/* eslint-disable no-throw-literal */
import React, { PureComponent } from 'react';
import './Login.scss';
// import { Button, Input } from 'components';
// import MarkazIcon from 'assets/icons/logo.png';
import connect from 'shared/context/connect';
import { handleLogin, handleToken } from 'shared/context/actions';

interface Props {
  history: { push, location },
  intl: { formatMessage },
  onHandleLogin,
  onHandleToken,
}

interface State {
  email?: string,
  password?: string,
  isSubmit?: boolean,
}

const AUTH_URL = process.env.REACT_APP_AUTH;
const AUTH_APP_NAME = process.env.REACT_APP_AUTH_APP_NAME;

class Login extends PureComponent<Props, State> {

  async componentDidMount() {
    const queryToken = new URLSearchParams(document.location.search).get('token');
    const { onHandleToken } = this.props;
    // const ssoFlag = new URLSearchParams(document.location.search).get('sso');
    const isTokenValid = await onHandleToken(queryToken);
    if (!queryToken || !isTokenValid) {
      const ssoUrl = `${AUTH_URL}/sso/checkpoint?appName=${AUTH_APP_NAME}&redirectUrl=${document.location.href}`;
      window.location.replace(ssoUrl);
    }
  }

  render() {
    return (
      <div className="login"> </div>
    );
  }
}

const mapStateToProps = ({ rootState }) => ({
  clientData: rootState.clientData,
});

const mapDispatchToProps = ({
  onHandleLogin: handleLogin,
  onHandleToken: handleToken,
});

export default connect(mapStateToProps, mapDispatchToProps)(Login);
